<form [formGroup]="searchForm" (ngSubmit)="onClickSearch()">
  <mat-card class="cur-card">
    <mat-card-content>
      <div fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="100">
          <mat-label>契約番号</mat-label>
          <input matInput formControlName="ctrVisitNo" />
        </mat-form-field>
        <mat-card-actions class="btn_area_right" style="margin-left: 40px; margin-top: 10px">
          <button type="submit" mat-raised-button color="primary" class="btn btnSearch" [disabled]="searchForm?.get('ctrVisitNo')?.invalid"
              >検索</button>
        </mat-card-actions>
        <mat-card-actions class="btn_area_right" style="margin-left: 10px; margin-top: 10px">
          <button type="button" mat-raised-button color="primary" class="btn btnClear"
            [disabled]="searchForm?.get('ctrVisitNo')?.value === ''" (click)="onClickClear()">クリア</button>
        </mat-card-actions>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="start center" *ngIf="searchFlg">
          <mat-form-field appearance="fill" class="input-form" fxFlex="30" fxFlex.lt-md="100">
            <mat-label>支払契約番号</mat-label>
            <input matInput formControlName="claimCtrNo" class="font-color-display-only" readonly="true" />
          </mat-form-field>  
          <mat-form-field appearance="fill" class="input-form" fxFlex="30" fxFlex.lt-md="100">
            <mat-label>料金種別</mat-label>
            <input matInput formControlName="ocUCtrClsfy" class="font-color-display-only" readonly="true" />
          </mat-form-field>
            <mat-form-field appearance="fill" class="input-form" fxFlex="100%" fxFlex.lt-md="100">
              <mat-label>お客さま情報</mat-label>
              <textarea matInput formControlName="visitInfo" class="font-color-display-only custom-info" rows="4"
                readonly="true">
              </textarea>
            </mat-form-field>
            <mat-form-field appearance="fill" class="input-form" fxFlex="100%" fxFlex.lt-md="100">
              <mat-label>請求先情報</mat-label>
              <textarea matInput formControlName="clmtoInfo" class="font-color-display-only" rows="4" readonly="true">
              </textarea>
          </mat-form-field>
      </div>
      <!-- タイトル + 新規ボタン -->
      <div class="header-container"  *ngIf="searchFlg">  
        <mat-card-header>
          <mat-card-title class="page-title">{{aceptTitle}}</mat-card-title>
        </mat-card-header>
        <button type="button" mat-raised-button color="primary" [disabled]="disabledNewButton"
          [disabled]="searchForm?.get('ctrVisitNo')?.value === ''" (click)="onClickNew()">  新規
        </button>
      </div>  
      <div *ngIf="searchFlg">
            <mat-card-content>
            <div class="table-responsive">
              <!-- 口座振替の場合表示 -->
              @if (kouzaFlg) {
                <mat-radio-group [value]="selectDirectVal">
                  <table mat-table [dataSource]="dataDirectSource">
                  <ng-container matColumnDef="select">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <mat-radio-button color="primary"
                        [value]="row.select"
                        (change)="selectDirectOne(row)"/>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="registrationDate">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>登録日</th>
                    <td mat-cell *matCellDef="let row">{{ row.registrationDate }}</td>
                  </ng-container>
                  <ng-container matColumnDef="updateDate">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>更新日</th>
                    <td mat-cell *matCellDef="let row">{{ row.updateDate }}</td>
                  </ng-container>
                  <ng-container matColumnDef="aceptStateAname">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>受付状態</th>
                    <td mat-cell *matCellDef="let row">{{ row.aceptStateAname }}</td>
                  </ng-container>
                  <ng-container matColumnDef="hubiReason">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>不備理由</th>
                    <td mat-cell *matCellDef="let row">{{ row.hubiReason }}</td>
                  </ng-container>
                  <ng-container matColumnDef="bankfcMei">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>金融機関名</th>
                    <td mat-cell *matCellDef="let row">{{ row.bankfcMei }}</td>
                  </ng-container>
                  <ng-container matColumnDef="brncnm">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>支店名</th>
                    <td mat-cell *matCellDef="let row">{{ row.brncnm }}</td>
                  </ng-container>
                  <ng-container matColumnDef="bankAccountName">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>預金者名義</th>
                    <td mat-cell *matCellDef="let row">{{ row.bankAccountName }}</td>
                  </ng-container>
                  <ng-container matColumnDef="dptClsfy">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>預金種別</th>
                    <td mat-cell *matCellDef="let row">{{ row.dptClsfy }}</td>
                  </ng-container>
                  <ng-container matColumnDef="kouzaNo">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>口座番号</th>
                    <td mat-cell *matCellDef="let row">{{ row.kouzaNo }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedDirectColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedDirectColumns;"></tr>
                  </table>
                </mat-radio-group>
              }
              <!-- クレジットの場合のみ表示 -->
              @if (crdFlg) {
                <mat-radio-group [value]="selectCreditVal">
                  <table mat-table [dataSource]="dataCreditSource">
                  <ng-container matColumnDef="select">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <mat-radio-button color="primary"
                        [value]="row.select"
                        (change)="selectCreditOne(row)" />
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="registrationDate">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>登録日</th>
                    <td mat-cell *matCellDef="let row">{{ row.registrationDate }}</td>
                  </ng-container>
                  <ng-container matColumnDef="updateDate">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>更新日</th>
                    <td mat-cell *matCellDef="let row">{{ row.updateDate }}</td>
                  </ng-container>
                  <ng-container matColumnDef="aceptStateAname">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>受付状態</th>
                    <td mat-cell *matCellDef="let row">{{ row.aceptStateAname }}</td>
                  </ng-container>
                  <ng-container matColumnDef="hubiReason">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>不備理由</th>
                    <td mat-cell *matCellDef="let row">{{ row.hubiReason }}</td>
                  </ng-container>
                  <ng-container matColumnDef="crdKananame">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>クレジットカード名義(カナ)</th>
                    <td mat-cell *matCellDef="let row">{{ row.crdKananame }}</td>
                  </ng-container>
                  <ng-container matColumnDef="cregitCoCode">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>クレジット企業コード</th>
                    <td mat-cell *matCellDef="let row">{{ row.cregitCoCode }}</td>
                  </ng-container>
                  <ng-container matColumnDef="cregitCoName">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>クレジット企業名</th>
                    <td mat-cell *matCellDef="let row">{{ row.cregitCoName }}</td>
                  </ng-container>
                  <ng-container matColumnDef="dbKey">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>DBキー</th>
                    <td mat-cell *matCellDef="let row">{{ row.dbKey }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedCreditColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedCreditColumns;"></tr>
                  </table>
                </mat-radio-group>
              }
            </div>
          </mat-card-content>  
      </div>
    </mat-card-content>
  </mat-card>
  <!-- kouza -->
  <mat-card class="cur-card" *ngIf="searchFlg">
    <mat-card-header>
      <mat-card-title>{{kouzaTitle}}情報</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (noResult){
      <div>
        <div fxLayout="row wrap" fxLayoutAlign="start center">
          <mat-radio-group class="kouza-radio-group">
           <div fxLayout="row">
              <mat-radio-button  class="kouza-radio-button"  
              [checked]="selectedKouzaType === PAYMETHOD.KOUZA"
              [value]="PAYMETHOD.KOUZA" (change)="onSelectDirect()">口座振替
              </mat-radio-button>
            </div>
            <br>
            <div fxLayout="row"> 
              <mat-radio-button class="kouza-radio-button" 
              [checked]="selectedKouzaType === PAYMETHOD.KOUZA_Y"
              [value]="PAYMETHOD.KOUZA_Y" (change)="onSelectPost()">ゆうちょ振替
              </mat-radio-button>
            </div>
          </mat-radio-group>
        </div>
      </div>
      }
      <!-- 口座振替の場合のみ表示 -->
      @if (kouzaFlg){
        @if (noResult){
        <div fxLayout="row wrap" fxLayoutAlign="start center">
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>お客さま記入番号</mat-label>
            <input matInput
              formControlName="visitKyhNo"
            />
          </mat-form-field>
        </div>
        }
        <div fxLayout="row wrap" fxLayoutAlign="start center">
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>口座名義（漢字）</mat-label>
            <input matInput
              formControlName="mozmigKanji"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>口座名義（カナ）</mat-label>
            <input matInput
              formControlName="mozmigKana"
            />
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="start center">
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>金融機関コード</mat-label>
            <input matInput
              formControlName="bankfcCode"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>金融機関名</mat-label>
            <input matInput
              formControlName="bankfcMei"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>支店コード</mat-label>
            <input matInput
              formControlName="branchCode"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>支店名</mat-label>
            <input matInput
              formControlName="branchMei"
            />
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="start center">
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>預金種別</mat-label>
            <input matInput
              formControlName="dptcls"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>口座番号</mat-label>
            <input matInput
              formControlName="accntn"
            />
          </mat-form-field>
        </div>
      }
      <!-- クレジットの場合のみ表示 -->
      @if (crdFlg){
        <div fxLayout="row wrap">
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
          <mat-label>お客さま記入番号</mat-label>
          <input matInput formControlName="visitKyhNo" />
          </mat-form-field>
        </div>

        <div fxLayout="row wrap">
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>クレジットカード名(カナ)</mat-label>
            <input matInput formControlName="crdKananame" />
          </mat-form-field>
        </div>
      
        <div fxLayout="row wrap">
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>クレジット企業コード</mat-label>
            <input matInput formControlName="cregitCoCode" />
          </mat-form-field>
        </div>
      
        <div fxLayout="row wrap">
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>クレジット企業名</mat-label>
            <input matInput formControlName="cregitCoName" />
          </mat-form-field>
        </div>
      
        <div fxLayout="row wrap">
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>DBキー</mat-label>
            <input matInput formControlName="dbKey"  />
          </mat-form-field>
        </div>
      }

    </mat-card-content>
  </mat-card>
  
  <!-- fubi_riyu-->
  <mat-card class="cur-card" *ngIf="searchFlg">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlex="100">
      <div fxLayout="row" fxLayoutAlign="start start" fxFlex="100">
        <mat-card-header>
          <mat-card-title>不備理由</mat-card-title>
        </mat-card-header>
      </div>
 
      <div fxLayout="row" fxLayoutAlign="start start" fxFlex="60">
          <mat-tab-group [selectedIndex]="selectedTab" (selectedIndexChange)="onTabChange($event)">>
          <!-- 口座の場合のみ表示」 -->
          @if (kouzaFlg) {
            <mat-tab label="依頼書不備">
              <div class="table-responsive">
                <table mat-table
                  [dataSource]="reqdocFubiDataSource">
                  <ng-container matColumnDef="select">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>選択</th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox
                        color="primary"
                        [checked]="reqdocFubiSelection.isSelected(row)"
                        [disabled]="fubiDisabled"
                        (change)="onReqdocFubiChange(row)"
                      />
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="value">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>理由コード</th>
                    <td mat-cell *matCellDef="let row">{{ row.value }}</td>
                  </ng-container>
                  <ng-container matColumnDef="viewValue">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>不備内容</th>
                    <td mat-cell *matCellDef="let row">{{ row.viewValue }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true" ></tr>
                  <tr mat-row
                    *matRowDef="let row; columns: displayedColumnsCol"
                    class="clickable-mat-row"
                  ></tr>
                </table>
              </div>
            </mat-tab>
            <mat-tab label="銀行不備">
              <div class="table-responsive">
                <table mat-table
                  [dataSource]="bankFubiDataSource">
                  <ng-container matColumnDef="select">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>選択</th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox
                        color="primary"
                        [checked]="bankFubiSelection.isSelected(row)"
                        [disabled]="fubiDisabled"
                        (change)="onBankFubiChange(row)"
                      />
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="value">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>理由コード</th>
                    <td mat-cell *matCellDef="let row">{{ row.value }}</td>
                  </ng-container>
                  <ng-container matColumnDef="viewValue">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>不備内容</th>
                    <td mat-cell *matCellDef="let row">{{ row.viewValue }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true" ></tr>
                  <tr mat-row
                    *matRowDef="let row; columns: displayedColumnsCol"
                    class="clickable-mat-row"
                  ></tr>
                </table>
              </div>
            </mat-tab>
            <mat-tab label="ＳＧ業務不備">
              <div class="table-responsive">
                <table mat-table
                  [dataSource]="sgFubiDataSource">
                  <ng-container matColumnDef="select">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>選択</th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox
                        color="primary"
                        [checked]="sgFubiSelection.isSelected(row)"
                        [disabled]="fubiDisabled"
                        (change)="onSgFubiChange(row)"
                      />
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="value">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>理由コード</th>
                    <td mat-cell *matCellDef="let row">{{ row.value }}</td>
                  </ng-container>
                  <ng-container matColumnDef="viewValue">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>不備内容</th>
                    <td mat-cell *matCellDef="let row">{{ row.viewValue }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true" ></tr>
                  <tr mat-row
                    *matRowDef="let row; columns: displayedColumnsCol"
                    class="clickable-mat-row"
                  ></tr>
                </table>
              </div>
            </mat-tab>
          }
          <!-- クレジットの場合のみ表示」 -->
          @if (crdFlg) {
            <mat-tab label="依頼書不備">
              <div class="table-responsive">
                <table mat-table
                  [dataSource]="missInfoFubiDataSource">
                  <ng-container matColumnDef="select">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>選択</th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox
                        color="primary"
                        [checked]="missInfoSelection.isSelected(row)"
                        [disabled]="fubiDisabled"
                        (change)="onMissInfoFubiChange(row)"
                      />
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="value">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>理由コード</th>
                    <td mat-cell *matCellDef="let row">{{ row.value }}</td>
                  </ng-container>
                  <ng-container matColumnDef="viewValue">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>不備内容</th>
                    <td mat-cell *matCellDef="let row">{{ row.viewValue }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true" ></tr>
                  <tr mat-row
                    *matRowDef="let row; columns: displayedColumnsCol"
                    class="clickable-mat-row"
                  ></tr>
                </table>
              </div>
            </mat-tab>
            <mat-tab label="カード情報不備">
              <div class="table-responsive">
                <table mat-table
                  [dataSource]="cardFubiDataSource">
                  <ng-container matColumnDef="select">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>選択</th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox
                        color="primary"
                        [checked]="cardFubiSelection.isSelected(row)"
                        [disabled]="fubiDisabled"
                        (change)="onCardFubiChange(row)"
                      />
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="value">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>理由コード</th>
                    <td mat-cell *matCellDef="let row">{{ row.value }}</td>
                  </ng-container>
                  <ng-container matColumnDef="viewValue">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>不備内容</th>
                    <td mat-cell *matCellDef="let row">{{ row.viewValue }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true" ></tr>
                  <tr mat-row
                    *matRowDef="let row; columns: displayedColumnsCol"
                    class="clickable-mat-row"
                  ></tr>
                </table>
              </div>
            </mat-tab>
            <mat-tab label="ＳＧ業務不備">
              <div class="table-responsive">
                <table mat-table
                  [dataSource]="registrationFubiDataSource">
                  <ng-container matColumnDef="select">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>選択</th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox
                        color="primary"
                        [checked]="registrationFubiSelection.isSelected(row)"
                        [disabled]="fubiDisabled"
                        (change)="onRegistrationInfoFubiChange(row)"
                      />
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="value">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>理由コード</th>
                    <td mat-cell *matCellDef="let row">{{ row.value }}</td>
                  </ng-container>
                  <ng-container matColumnDef="viewValue">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>不備内容</th>
                    <td mat-cell *matCellDef="let row">{{ row.viewValue }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true" ></tr>
                  <tr mat-row
                    *matRowDef="let row; columns: displayedColumnsCol"
                    class="clickable-mat-row"
                  ></tr>
                </table>
              </div>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
 
      <div fxLayout="column wrap" fxLayoutAlign="start start" fxFlex="40">
        <div style="height:35px;"></div>
        <!-- 口座の場合のみ表示」 -->
        @if (kouzaFlg) {
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>預金者名義の相違</mat-label>
            <textarea matInput rows="2"
              formControlName="dptprsMeigiDiff"
            >
            </textarea>
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>その他不備理由</mat-label>
            <textarea matInput  rows="1"
              formControlName="etcHubirsn"
            >
            </textarea>
          </mat-form-field>
        }
        <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
          <mat-label>ご契約者名</mat-label>
          <input matInput
            formControlName="ctrerMei"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
          <mat-label>郵便番号</mat-label>
          <input matInput
            formControlName="postno"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-form" fxFlex="50" fxFlex.lt-md="100">
          <mat-label>都道府県名</mat-label>
          <input matInput
            formControlName="prefectureaname"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-form" fxFlex="100" fxFlex.lt-md="100">
          <mat-label>行政市区名</mat-label>
          <textarea matInput  rows="1"
            formControlName="administrativecitywardname"
          >
          </textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-form" fxFlex="100" fxFlex.lt-md="100">
          <mat-label>町名</mat-label>
          <textarea matInput  rows="1"
            formControlName="choname"
          >
          </textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-form" fxFlex="100" fxFlex.lt-md="100">
          <mat-label>丁目</mat-label>
          <textarea matInput  rows="1"
            formControlName="chome"
          >
          </textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-form" fxFlex="100" fxFlex.lt-md="100">
          <mat-label>番地・号</mat-label>
          <textarea matInput  rows="1"
            formControlName="buildingnumber"
          >
          </textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-form" fxFlex="100" fxFlex.lt-md="100">
          <mat-label>建物名</mat-label>
          <textarea matInput  rows="1"
            formControlName="visitSupadrAname"
          >
          </textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-form" fxFlex="100" fxFlex.lt-md="100">
          <mat-label>目標・部屋番号</mat-label>
          <textarea matInput  rows="1"
            formControlName="visitYagouAname"
          >
          </textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-form" fxFlex="100" fxFlex.lt-md="100">
          <mat-label>備考欄</mat-label>
          <textarea matInput  rows="3"
            formControlName="remarks"
          >
          </textarea>
        </mat-form-field>
      </div>
    </div>
  </mat-card>
   <!-- fubi_riyu-->
   <div *ngIf="searchFlg">
    <div>
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="80">
        <mat-card class="cur-card">
          <mat-card-header>
            <mat-card-title>申込情報</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="35">
              <mat-form-field appearance="fill" class="input-form" fxFlex="100" fxFlex.lt-md="100">
                <mat-label>登録日</mat-label>
                <input matInput
                  formControlName="regDate"
                  class="font-color-display-only"
                  readonly="true"
                />
              </mat-form-field>
              <mat-form-field appearance="fill" class="input-form" fxFlex="100" fxFlex.lt-md="100">
                <mat-label>登録者</mat-label>
                <input matInput
                  formControlName="creator"
                  class="font-color-display-only"
                  readonly="true"
                />
              </mat-form-field>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="35">
              <mat-form-field appearance="fill" class="input-form" fxFlex="100" fxFlex.lt-md="100">
                <mat-label>最終更新日</mat-label>
                <input matInput
                  formControlName="sshksnDate"
                  class="font-color-display-only"
                  readonly="true"
                />
              </mat-form-field>
              <mat-form-field appearance="fill" class="input-form" fxFlex="100" fxFlex.lt-md="100">
                <mat-label>最終更新者</mat-label>
                <input matInput
                  formControlName="sshUpdator"
                  class="font-color-display-only"
                  readonly="true"
                />
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="15">
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="50">
          <mat-card-actions class="input-form" fxFlex="10">
            <button type="button" mat-raised-button
              color="primary"
              class="btn btnSearch"
              (click)="onClickDelete()"
              [disabled]="kohuricreMskmaceptMno === null"
            >取消</button>
          </mat-card-actions>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="50">
          <mat-card-actions class="input-form" fxFlex="10">
            <button type="button" mat-raised-button
              color="primary"
              class="btn btnSearch"
              (click)="setEnableKofuri();setEnableCredit();onClickRegist();"
              [disabled]="disabledBtnRegist()"
            >登録</button>
          </mat-card-actions>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="100">
          <mat-card-actions class="input-form" fxFlex="25">
            <button type="button" mat-raised-button
              color="primary"
              class="btn btnSearch"
              [disabled]="disabledBtnPrint()"
              (click)="onClickPrint()"
            >不備のお知らせ出力</button>
          </mat-card-actions>
        </div>
      </div>
    </div>
  </div>  
</form>